module.exports = __webpack_public_path__ + "static/media/privacy_policy.4586e7a0.pdf";